import React, { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';

import Table from '~components/molecules/Table';

import UtilFunctions from '~utils/functions';
import { ModuleEnum, PermissionsEnum, RegionStatusEnum } from '~utils/enums';
import ActionButton from '~components/atoms/ActionButton';
import { TRegion } from '~types/feat/branch';
import * as Styles from './_regionsTable.module.scss';

const RegionsTable = () => {
    const {
        Misc:
        {
            dateTimeFormat,
            renderBinaryStatusChip,
        },
    } = UtilFunctions;

    const dispatch = useAppDispatch();

    const index = useAppSelector(state => state.branch.regionListing.index);
    const regionListing = useAppSelector(state => state.branch.regionListing.data);
    const isLoading = useAppSelector(state => state.branch.loadings.getRegionListing);

    const userAccess = useAppSelector(state => state.auth.userDetails.access);
    const hasEditAccess = !!userAccess.find(item => item.permission === PermissionsEnum.Edit)?.modules.find(module => module === ModuleEnum.BranchManagement);

    const setRegionDetailsModalIsOpen = (isOpen: boolean) => dispatch(combinedActions.branchSetRegionDetailsModalIsOpen(isOpen));
    const setSelectedRegion = (selectedRegion: TRegion) => dispatch(combinedActions.branchSetSelectedRegion(selectedRegion));
    const setIsEditing = (isEditMode: boolean) => dispatch(combinedActions.branchSetRegionDetailsModalIsEditing(isEditMode));
    const setDeleteModalIsOpen = (isOpen: boolean) => dispatch(combinedActions.branchSetDeleteRegionModalIsOpen(isOpen));

    useEffect(() => {
        dispatch(combinedActions.branchGetRegionListingAttempt());
    }, [index]);

    const header = [
        'REGION NAME',
        'STATUS',
        'CREATED AT',
        'ACTION',
    ];

    const handleViewRegionsDetailsClick = (selectedRegion: TRegion) => {
        setRegionDetailsModalIsOpen(true);
        setSelectedRegion(selectedRegion);
    };

    const handleEditRegionsClick = (selectedRegion: TRegion) => {
        setIsEditing(true);
        setRegionDetailsModalIsOpen(true);
        setSelectedRegion(selectedRegion);
    };

    const handleDeleteBranchClick = (selectedRegion: TRegion) => {
        setDeleteModalIsOpen(true);
        setSelectedRegion(selectedRegion);
    };

    const body = regionListing.map(region => {
        const {
            regionId,
            regionName,
            status,
            createdAt,
        } = region;

        const actionButtons = (
            <div
                key={regionId}
                className={Styles['button-container']}
            >
                <div>
                    <ActionButton
                        label='View'
                        onClick={() => handleViewRegionsDetailsClick(region)}
                    />

                    <>
                        {hasEditAccess
                        && (
                            <ActionButton
                                label='Edit'
                                onClick={() => handleEditRegionsClick(region)}
                            />
                        )
                        }

                        {(hasEditAccess && status !== RegionStatusEnum.Deactivated)
                        && (
                            <ActionButton
                                label='Delete'
                                onClick={() => handleDeleteBranchClick(region)}
                                className={Styles.danger}
                            />
                        )
                        }
                    </>
                </div>
            </div>
        );

        return [
            regionName,
            status ? renderBinaryStatusChip(status, RegionStatusEnum[status]) : '-',
            dateTimeFormat(createdAt),
            actionButtons,
        ];
    });

    return (
        <Table
            header={header}
            body={body}
            isLoading={isLoading}
        />
    );
};

export default RegionsTable;
